// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"1814126c","204":"099fa38c","466":"b8a3fb86"}[chunkId] + ".chunk.js";
};